<template>
    <div class="online-search-container">
        <div class="head-container" v-if="!isShowDetail">
            <div class="img-container">
                <img src="../../assets/logo.png" class="logo" alt=""/>
                <div class="title">猎户星</div>
            </div>

            <div class="input-container">
                <a-input-search
                        v-model="searchText"
                        placeholder="请输入关键字进行搜索"
                        class="input"
                        @keyup.enter.native="search"

                >
                    <a-button @click.native="search" slot="enterButton" type="primary">
                        <a-icon type="search"/>
                        搜索
                    </a-button>
                </a-input-search>
            </div>
        </div>

        <template v-else>
            <div class="detail-search-row">
                <div class="img-container">
                    <img src="../../assets/logo.png" class="logo" alt=""/>
                    <div class="title">猎户星</div>
                </div>
                <div class="input-container">
                    <a-input-search
                            v-model="searchText"
                            placeholder="请输入关键字进行搜索"
                            class="input"
                            @keyup.enter.native="search"
                    >
                        <a-button @click.native="search" slot="enterButton" type="primary">
                            <a-icon type="search"/>
                            搜 索
                        </a-button>
                    </a-input-search>
                </div>
            </div>
            <div class="result-number-tip">猎户星为您搜索到相关结果约 {{ pagination.total }} 个</div>

            <div class="search-result-list-container">
                <SearchResult
                        v-for="(result, index) in resultList"
                        :key="index"
                        :info="result"
                        :keyword="lastSearchText"
                />
            </div>

            <div class="pagination-container" v-if="resultList.length">
                <a-pagination v-bind="pagination" show-quick-jumper @change="onPaginationChange"/>
            </div>
        </template>

        <div class="loading-container" v-if="isShowDetail">
            <div class="loading box" v-if="loading">
                <a-icon  type="loading" :spin="true"/>
                <p>努力加载中...</p>
            </div>
            <div class="finish box"  v-else>
                <a-icon type="check-circle" theme="filled" />
                <p>加载完成</p>
            </div>
        </div>
    </div>
</template>

<script>
  import SearchResult from './searchResult'
  import { searchThenGetTaskIdApi, getSearchResultApi } from '@/api/OnlineSearch/index'
  import { onHttpResponseSilent } from '../../utils/request'

  export default {
    components: { SearchResult },
    data() {
      return {
        isShowDetail: false,

        searchText: '',
        pagination: {
          current: 1,
          pageSize: 20,
          total: 0,
          showTotal: (total) => `共 ${total} 条`,
          size: 'default'
        },

        maxPn: 10,
        taskId: 0,

        pollingTimer: null,
        loading: false,
        resultList: [],
        lastSearchText: '',
        stopNum: 0
      }
    },
    beforeRouteLeave(to, from, next) {
      clearTimeout(this.pollingTimer)
      this.pollingTimer = null
      this.loading = false
      next()
    },

    methods: {
      onPaginationChange(page) {
        this.pagination.current = page
        this.getSearchResult(false)
      },

      search() {
        if (!this.searchText) return
        this.lastSearchText = this.searchText
        this.loading = true
        this.isShowDetail = true
        clearTimeout(this.pollingTimer)
        this.pagination.current = 1

        searchThenGetTaskIdApi(this.searchText, this.maxPn)
          .then(onHttpResponseSilent)
          .then((res) => {
            if (res.code != 200) {
              this.$message.error(res.msg)
              return
            }
            this.taskId = res.extra.taskId
            this.getSearchResult(false)
          })
      },

      //轮询获取数据
      getSearchResult(isAuto = false) {
        clearTimeout(this.pollingTimer)

        let query = {
          pn: this.pagination.current,
          pageSize: this.pagination.pageSize,
          taskId: this.taskId,
          parseFailedWebStatus: 1
        }

        this.loading = true
        getSearchResultApi(query)
          .then(onHttpResponseSilent)
          .then(({ data, extra }) => {
            this.resultList = data
            this.isShowDetail = true
            let newPageTotal = extra.page?.pageCount || 0
            if (this.pagination.total == newPageTotal) {
              this.stopNum++
            } else {
              this.stopNum = 0
              this.pagination.total = newPageTotal
            }
            if (!isAuto) {
              // 如果不是自动的,滚一下
              this.$nextTick(() => {
                window.scrollTo({
                  left: 0,
                  top: 0,
                  behavior: 'smooth'
                })
              })
            }

            // 如果在最后一页 且填满了数据，不要轮询了
            // if (this.pagination.current >= this.maxPn && this.resultList.length === 20) {
            //   return
            // }
            // 如果当前在最后一页，继续轮询
            // if (this.pagination.current >= extra.page?.pageCount) {
            //   this.pollingTimer = setTimeout(() => {
            //     this.getSearchResult(true)
            //   }, 5 * 1000)
            // }
            //请求12次 目前是1分钟 如果请求12次都是没有新数据 说明搜索结束了
            if (this.stopNum >= 12) {
              this.loading = false
              this.$message.success('搜索结束')

            } else {
              this.pollingTimer = setTimeout(() => {
                this.getSearchResult(true)
              }, 5 * 1000)
            }

            // if (this.pagination.current > 1) {
            //   this.loading = false
            // }
            // if (this.resultList.length) {
            //   this.loading = false
            // }
          })
      }
    }
  }
</script>

<style lang="less" scoped>
    .online-search-container {
        width: 100%;
        margin-top: 4px;
        background: white;
        min-height: calc(100vh - 48px - 4px);

        .head-container {
            margin-top: 15vh;

            .img-container {
                display: flex;
                justify-content: center;
                align-items: center;

                .logo {
                    width: 70px;
                    margin-right: 10px;
                }

                .title {
                    font-size: 28px;
                    font-weight: bold;
                    color: #333333;
                }
            }

            .input-container {
                margin-top: 50px;
                width: 100%;
                justify-content: center;
                align-items: center;
                display: flex;
                position: relative;

                .input {
                    width: 55vw;
                    height: 70px;
                }
            }
        }



        .detail-search-row {
            display: flex;
            align-items: center;
            margin-top: 40px;

            .img-container {
                display: flex;
                align-items: center;
                margin-right: 20px;
                margin-left: 40px;

                .logo {
                    width: 49px;
                    margin-right: 10px;
                }

                .title {
                    font-size: 20px;
                    font-weight: bold;
                    color: #333333;
                }

                .input-container {
                    margin-top: 50px;
                    width: 100%;
                    justify-content: center;
                    align-items: center;
                    display: flex;
                    position: relative;

                    .input {
                        width: 55vw;
                        height: 70px;
                    }
                }
            }

            .input-container {
                width: 640px;
                justify-content: center;
                align-items: center;
                display: flex;
                position: relative;

                .input {
                    width: 100%;
                    height: 48px;
                }
            }
        }

        .result-number-tip {
            font-size: 14px;
            font-weight: 400;
            color: #bbbbbb;
            padding-left: 185px;
            margin-top: 4px;
        }

        .search-result-list-container {
            padding-left: 155px;
            padding-right: 10vw;
            min-height: 20vh;
        }

        .pagination-container {
            width: 1155px;
            text-align: right;
            margin: 30px 0;
        }
    }
</style>

<style lang="less">
    .online-search-container {
        .head-container {
            .ant-input {
                border-top-left-radius: 8px !important;
                border-bottom-left-radius: 8px !important;
                padding-left: 45px;
                font-size: 16px;
            }

            .ant-btn {
                border-top-right-radius: 8px !important;
                border-bottom-right-radius: 8px !important;
                font-size: 18px;
            }

            .ant-input-wrapper {
                height: 100%;

                .ant-input {
                    height: 100%;
                }

                .ant-input-search-button {
                    height: 100%;
                    width: 150px;
                }
            }
        }

        .detail-search-row {
            .ant-input {
                border-top-left-radius: 8px !important;
                border-bottom-left-radius: 8px !important;
                padding-left: 25px;
                font-size: 15px;
            }

            .ant-btn {
                border-top-right-radius: 8px !important;
                border-bottom-right-radius: 8px !important;
                font-size: 18px;
            }

            .ant-input-wrapper {
                height: 100%;

                .ant-input {
                    height: 100%;
                }

                .ant-input-search-button {
                    height: 100%;
                    width: 120px;
                }
            }
        }
    }
    .loading-container{
        position: fixed;
        width: 97px;
        height: 81px;
        background: #F8FAFC;
        border-radius: 4px;
        right: 50px;
        bottom: 50px;
        color: #3C93FF;
        text-align: center;
        font-weight: bold;
        padding: 15px 0;
        i{
            font-size: 30px;
        }
        p{
            margin-top:5px;
        }
    }
</style>
